"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useId = void 0;

var _react = require("react");

var useId = function useId() {
  var id = (0, _react.useRef)("id-".concat(Math.round(Math.random() * 1e9)));
  return id.current;
};

exports.useId = useId;